module.exports = "<button id=\"selectedItem\" (click)=\"toggleOpen()\">\n  {{ _selected && _selected.label | translate  }}\n</button>\n<ul [class.open]=\"open\">\n  <li *ngFor=\"let item of items\"\n      [class.selected]=\"isItemSelected(item)\" \n      [class.disabled]=\"item.disabled\"\n      (click)=\"selectItem(item)\">\n    {{ item.label | translate }}\n  </li>\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/tab-select/tab-select.component.html
// module id = ./src/app/common/tab-select/tab-select.component.html
// module chunks = main